const t = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 6.5h-9.5a.51.51 0 0 1-.36-.15L8.8 5a1.52 1.52 0 0 0-1.08-.5H4.29A1.79 1.79 0 0 0 2.5 6.29v11.42a1.79 1.79 0 0 0 1.79 1.79h15.42a1.79 1.79 0 0 0 1.79-1.79V8A1.5 1.5 0 0 0 20 6.5Z" fill="currentColor"></path></svg>';
export {
  t as default
};
